import {
  InfoIcon,
  NegativeIcon,
  NeutralsIcon,
  PositiveIcon,
  WarningIcon
} from "./chunk-52U6OKP2.mjs";

// src/components/alert-icon/usecase/use-handle-icon.ts
function useHandleIcon(options) {
  const { status } = options;
  switch (status) {
    case "info":
      return InfoIcon;
    case "negative":
      return NegativeIcon;
    case "positive":
      return PositiveIcon;
    case "warning":
      return WarningIcon;
    case "neutrals":
      return NeutralsIcon;
    default:
      return NeutralsIcon;
  }
}
var use_handle_icon_default = useHandleIcon;

export {
  use_handle_icon_default
};
